<template>
  <div>
    <v-container fluid ref="table_container" class="pa-0">
      <v-row>
        <v-col
          v-for="(f, fi) in filtersVisible"
          :key="'f' + fi"
          :cols="filtersVisible.length < 6 ? '2' : null" class="pr-0"
        >
          <v-row dense
            ><v-col class="rm-label">{{ f.text }}</v-col></v-row
          >
          <v-row dense
            ><v-col>
              <v-autocomplete
                dense
                hide-details
                outlined
                class="rm-select"
                :items="f.listValuesFiltered"
                v-model="f.filterValues"
                @change="filterMatches"
                multiple
                clearable
                :title="f.text + ' Filter'"
              >
                <!-- <template v-slot:label>
                          <span style="font-size: 13px">{{ f.name }}</span>
                        </template> -->
                <template v-slot:selection="{ item, index }">
                  <span
                    style="font-size: 13px"
                    v-if="item && index === 0 && f.filterValues.length === 1"
                    class="blue--text text-caption"
                    :title="f.filterValues.join(', ')"
                  >
                    {{ f.filterValues[0] }}
                  </span>
                  <span
                    style="font-size: 13px"
                    v-else-if="item && index === 0"
                    class="blue--text text-caption"
                    :title="f.filterValues.join(', ')"
                  >
                    ({{ f.filterValues.length }} item{{
                      f.filterValues.length > 1 ? "s" : ""
                    }})
                  </span>
                </template>
                <!--<template v-slot:item="{ item }">
                          <span style="font-size: 13px">{{ item }}</span>
                        </template> -->
              </v-autocomplete>
            </v-col>
          </v-row>
        </v-col>
        <!-- <v-col class="mb-4">
          <v-badge
            v-if="selectedDocs.length"
            color="green"
            left
            overlap
            :content="selectedDocs.length"
          >
            <v-btn color="#eeeeee" @click="compareDocDetailsFull" elevation="0">
              <v-icon>mdi-compare</v-icon> Compare Selected</v-btn
            ><v-menu>
              <template v-slot:activator="{ on, attrs }">
                <v-btn
                  class="ml-2"
                  elevation="0"
                  color="#eeeeee"
                  v-bind="attrs"
                  v-on="on"
                >
                  Actions <v-icon>mdi-chevron-down</v-icon>
                </v-btn>
              </template>
              <v-list>
                <v-list-item @click="compareDocDetailsFull">
                  <v-list-item-title>Full compare view</v-list-item-title>
                </v-list-item>
                <v-list-item
                  @click="compareDocDetails"
                  :disabled="selectedDocs.length > 15"
                >
                  <v-list-item-title>Side-by-side view</v-list-item-title>
                </v-list-item>
                <v-list-item v-if="usesTags" @click="getDocumentTags">
                  <v-list-item-title>{{
                    tagsDialogue.subject + " Comparison"
                  }}</v-list-item-title>
                </v-list-item>
                <v-list-item @click="resetCompare">
                  <v-list-item-title
                    >Clear Selected Documents</v-list-item-title
                  >
                </v-list-item>
              </v-list>
            </v-menu>
          </v-badge>

          <v-btn
            v-else
            disabled
            color="#eeeeee"
            @click="compareDocDetailsFull"
            elevation="0"
          >
            <v-icon>mdi-compare</v-icon> Compare Selected</v-btn
          >
          <v-btn
            v-if="allowDesigner"
            style="float: right"
            icon
            x-small
            class="ml-3"
            title="Report Designer"
            @click="$emit('showDesigner')"
            ><v-icon>mdi-tools</v-icon></v-btn
          >
        </v-col> -->
      </v-row>
      <v-row  v-if="definitionChanged > 0 && internalViewDef"
        ><v-col>
          <!-- <div> -->
          <v-simple-table fixed-header>
            <template v-slot:default>
              <TableColumnHeaders
                :dataColumns="detailColumnsUsed"
                :preColumns="[]"
                :postColumns="['']"
                :rows="tasks"
                :stateKey="stateKey"
                :presetFilters="internalViewDef.columnFilters"
                :useJATheme="true"
                @sortby="setSort($event)"
                @filterApplied="applyColumnFilters($event)"
              ></TableColumnHeaders>
              <tbody @wheel.stop="pageScroll($event)">
                <tr
                  v-for="(d, di) in pageRows"
                  :key="'d' + d.level + '_' + d.detail.doc_id + '_' + di"
                  :class="d.cssClassRow"
                  :style="
                    d.expanded
                      ? 'cursor: zoom-out;'
                      : d.hasChildren
                      ? 'cursor: zoom-in;'
                      : ''
                  "
                      @contextmenu="openContextMenu($event, d.detail)"
                >
                      <!-- @click="selectRow($event, d.detail)" -->
                  <template>
                    <td
                      v-for="(c, ci) in detailColumnsUsed"
                      :key="'d' + d.detail.doc_id + 'c' + ci"
                      class="row-cell"
                      :class="
                        d.cssClassColumns[ci] +
                        (di === pageRows.length - 1 ? ' last-row' : '') +
                        (c.link ? ' showAsLink' : '')
                      "    
                      @click="cellClick($event, c, d.detail)"                  
                    >
                      <template>
                        <DocStatus
                          v-if="c.value === 'document_status'"
                          :doc_id="d.detail.doc_id"
                          sideAddendum
                        ></DocStatus>
                        <v-chip
                          v-else-if="c.value === 'task_status'"
                          dense
                          small
                          class="status-chip"
                          label
                          :color="d.detail.task_status_colour"
                          >{{ d.detail[c.value] }}</v-chip
                        >
                        <div v-else-if="c.value === 'document_comment_count'">
                          <CommentsCount
                            v-if="d.detail.document_comment_count != 0"
                            :document="d.detail"
                            @openDocument="openDocument"
                          ></CommentsCount>
                        </div>
                        <span v-else>
                          <!-- <v-icon
                            v-if="ci === 0"
                            class="mx-2"
                            :color="d.selected ? 'green' : 'black'"
                            style="font-size: 18px"
                            @click.stop="selectDocument(d)"
                            >{{
                              d.selected
                                ? "mdi-checkbox-marked"
                                : "mdi-checkbox-blank-outline"
                            }}</v-icon
                          > -->
                          {{ formatValue(c, d.detail[c.value]) }}</span
                        >
                      </template>
                    </td>
                    <td
                      class="last-column"
                      :class="di === pageRows.length - 1 ? 'last-row' : ''"
                    >
                          <v-btn
                            small
                            icon
                            @click.stop="openContextMenu($event, d.detail)"
                          >
                            <v-icon>mdi-dots-vertical</v-icon>
                          </v-btn>
                      <!-- <DocSummary
                        :doc_id="d.detail.doc_id"
                        icon
                        iconName="mdi-dots-horizontal"
                        @openDocument="openDocument"
                        @copyDocument="$emit('copyDocument', $event)"
                      ></DocSummary> -->
                      <!-- <v-icon>mdi-dots-horizontal</v-icon> -->
                    </td>
                  </template>
                </tr>
              </tbody>
            </template>
          </v-simple-table>
          <!-- </div><div --> </v-col
        ><v-col
          :style="{ height: vScroll.pageHeight + 'px' }"
          style="
            overflow-y: auto;
            overflow-x: hidden;
            margin-top: 50px;
            margin-left: -10px;
            max-width: 20px;
          "
          ref="scrollContainer"
          @scroll="setVScroll_"
        >
          <div
            ref="scrollBar"
            :style="{ height: vScroll.maxHeight, width: '1px' }"
          ></div>
          <!-- </div> -->
        </v-col>
      </v-row>
    </v-container>
    <v-dialog
      v-model="taskDialogue.show"
      max-width="600px"
      style="max-height: 600px"
      scrollable
    >
      <v-card v-if="taskDialogue.show">
        <v-card-title class="d-flex align-center">
          <div class="subtitle-1">
            Task - {{ taskDialogue.document_task.task_name }} (for
            {{ taskDialogue.document_task.role_name }})
          </div>
          <v-spacer />
          <v-btn
            icon
            large
            class="btn-background"
            @click="taskDialogue.show = false"
          >
            <v-icon>mdi-close</v-icon>
          </v-btn>
        </v-card-title>
        <v-card-text>
          <v-row>
            <v-col cols="12">
              <span
                >{{ taskDialogue.document_task.document_type }}:
                {{ taskDialogue.document_task.document_reference }} -
                {{ taskDialogue.document_task.document_name }}</span
              >
            </v-col>
            <v-col cols="6">
              <v-menu
                v-model="taskDialogue.due_date_menu"
                :close-on-content-click="false"
                :nudge-right="40"
                transition="scale-transition"
                offset-y
                min-width="auto"
              >
                <template v-slot:activator="{ on, attrs }">
                  <v-text-field
                    outlined
                    prepend-inner-icon="mdi-calendar"
                    @click:prepend-inner="taskDialogue.due_date_menu = true"
                    @blur="
                      taskDialogue.due_date = parseDate(
                        taskDialogue.due_date_text
                      )
                    "
                    v-bind="attrs"
                    v-on="on"
                    label="Due"
                    placeholder="Enter Date Due"
                    required
                    v-model="taskDialogue.due_date_text"
                    class="roundish"
                  ></v-text-field>
                </template>
                <v-date-picker
                  v-model="taskDialogue.due_date"
                  @input="
                    taskDialogue.due_date_menu = false;
                    taskDialogue.due_date_text = formatDate(
                      taskDialogue.due_date
                    );
                  "
                ></v-date-picker>
              </v-menu>
            </v-col>
            <v-col cols="6">
              <v-select
                v-model="taskDialogue.user_id_assigned"
                label="Assigned To:"
                :items="taskDialogue.user_list"
                item-text="user_name"
                item-value="user_id"
                clearable
                class="roundish"
                outlined
              ></v-select>
            </v-col>
          </v-row>
        </v-card-text>
        <v-card-actions class="d-flex justify-end px-6 py-4">
          <v-btn
            large
            color="primarylight"
            class="roundish"
            @click="saveTask(true)"
            :disabled="taskDialogue.busy"
            >Set task Cancelled</v-btn
          ><v-spacer></v-spacer>
          <v-btn
            large
            color="primarylight"
            class="roundish"
            @click="saveTask(false)"
            :disabled="taskDialogue.busy"
            >Save</v-btn
          >
        </v-card-actions>
      </v-card>
    </v-dialog>
    <DocSummary
      :doc_id="documentSummary.doc_id"
      :trigger="documentSummary.trigger"
      @openDocument="openDocument"
      @copyDocument="$emit('copyDocument', $event)"
    ></DocSummary>

            <v-menu
              v-model="contextMenu"
              absolute
              :position-x="posX"
              :position-y="posY"
              offset-y
              :close-on-content-click="false"
              nudge-width="300"
            >
              <v-card>
                <v-list dense>
                  <v-list-item @click="openTask(currentTask)">
                    <v-list-item-icon>
                      <v-icon>mdi-calendar-clock</v-icon>
                    </v-list-item-icon>
                    <v-list-item-title>Task</v-list-item-title>
                  </v-list-item>
                  <v-list-item @click="openDocumentSummary($event, currentTask)">
                    <v-list-item-icon>
                      <v-icon>mdi-pencil-box-outline</v-icon>
                    </v-list-item-icon>
                    <v-list-item-title>Document Summary</v-list-item-title>
                  </v-list-item>
                  <v-list-item @click="openDocument(currentTask)">
                    <v-list-item-icon>
                      <v-icon>mdi-book-open</v-icon>
                    </v-list-item-icon>
                    <v-list-item-title>Full Document</v-list-item-title>
                  </v-list-item>
                </v-list>
              </v-card>
            </v-menu>
    <ResponseHandler :serviceResponse="response"></ResponseHandler>
    <!-- <Loading :isVisible="isLoading" /> -->
  </div>
</template>
  
<script>
import axios from "axios";
import ResponseHandler from "@/components/ResponseHandler"; // @ is an alias to /src
// import Pagination from "@/components/cPagination";
// import TablePagination from "@/components/common/TablePager";
import DocStatus from "@/components/common/DocStatus";
// import DocumentVersionCompare from "@/components/audit/cDocumentVersionCompare";
// import DocumentSideBySide from "@/components/cDocumentSideBySide.vue";
import TableColumnHeaders from "@/components/common/TableColumnHeaders";
// import TablePager from "@/components/common/TablePager";
import DocSummary from "@/components/common/DocViewPopUp";
// import SimilarityTableRow from "@/components/jobArchitecture/similarityTableRow";
// import DocActionsMenu from "../common/DocActionsMenu.vue";
// import TagCompare from "@/components/jobArchitecture/TagCompare";
import CommentsCount from "@/components/comments/CommentsCount.vue";
import utils from "@/common/utils.js";
import dayjs from "dayjs";
import { mapState } from "vuex";
import jaCommon from "@/components/jobArchitecture/common.js";

let _sourceData = [];
const _page = "similarityAnalysis";
export default {
  name: _page,
  components: {
    ResponseHandler,
    // Pagination,
    // PageDescription,
    DocStatus,
    // DocumentVersionCompare,
    // DocumentSideBySide,
    TableColumnHeaders,
    // TablePagination,
    DocSummary,
    // SimilarityTableRow,
    // DocActionsMenu,
    // TagCompare,
    // TablePager,
    CommentsCount,
  },
  props: {
    height: { type: String, required: false, default: "" },
    ViewDef: { type: Object, required: true, default: null },
    definitionChanged: { type: Number, required: true, default: 0 },
    usesTags: { type: Boolean, required: false, default: false },
  },
  data: function () {
    return {
      tasks: [],
      internal_rows: [],
      visible_rows: [],
      stateKey: 1,
      selectedView: null,
      docStatusList: [],
      detailColumnsUsed: [],
      filtersVisible: [],
      columnFilters: [],
      sideBySide: { show: false, items: [] },
      fullCompareView: { show: false, highlightChanges: false, items: [] },
      sortColumn: { name: null, descending: false, isNumber: false },
      tableHeight: "700px",
      pageRows: [],
      filterList: [],
      utils: utils,
      response: null,
      docTypeIncluded: [],
      itemStatusIncluded: [],
      tempFilterText: "",
      filterText: "",
      selDoc: "",
      contextMenu: false,
      csvHeaders: [],
      dialog: false,
      filteredItems: [],
      tableHeightTimeout: null,
      posX: null,
      posY: null,
      currentTask: {},
      vScroll: {
        pageHeight: 0,
        maxHeight: 0,
        doSetup: false,
        dStart: 0,
        dEnd: 0,
        dMax: 0,
        inProgress: false,
        lineHeight: 48,
        pageRows: 0,
      },
      internalViewDef: null,
      selectedDocs: [],
      tagsDialogue: {
        show: false,
        doc_ids: [],
        subject: "",
        hierarchy_node_id: null,
        tag_type_id: null,
      },
      taskDialogue: {
        show: false,
        busy: false,
        document_task: null,
        user_list: [],
        user_id_assigned: null,
        due_date: null,
        due_date_text: "",
        due_date_menu: false,
        saveAction: "save",
      },
      documentSummary: {
        trigger: null,
        doc_id: null,
      },
    };
  },
  watch: {
    definitionChanged(val) {
      if (val) this.setView();
    },
  },
  computed: {
    rowClickAction() {
      return "opendoc";
    },
    ...mapState({
      isLoading: (state) => state.docs.loading,
      hierarchyTypes: (state) => state.docs.hierarchyTypes,
      documentTypes: (state) =>
        state.docs.docTypeSummary.filter((x) => x.tmpl_id),
    }),
  },
  created() {
    this.initView();
    this.$nextTick(() => {
      this.setTableHeight();
      this.setView();
    });
  },
  methods: {
    onPaneResize() {
      if (this.tableHeightTimeout) {
        clearTimeout(this.tableHeightTimeout);
        this.tableHeightTimeout = null;
      }
      this.tableHeightTimeout = setTimeout(() => this.setTableHeight(), 50);
    },
    setTableHeight() {
      if (!this.$refs.table_container) return;
      const pos = this.$refs.table_container.getBoundingClientRect();
      let availableHeight = window.innerHeight - pos.top - 120; // for header and footer
      if (availableHeight < 250) availableHeight = 250;
      this.tableHeight = `${availableHeight}px`;
      this.vScroll.pageRows = Math.floor(
        availableHeight / this.vScroll.lineHeight
      );
      this.vScroll.pageHeight = this.vScroll.pageRows * this.vScroll.lineHeight;
      this.vScroll.dStart = 0;
    },
    setVScroll_(event) {
      if (event.target.closest(".resizable-component")) return;
      if (this.vScroll.inProgress) {
        this.vScroll.inProgress = false;
        return;
      }
      let sl = this.$refs.scrollContainer.scrollTop;
      let max = this.$refs.scrollContainer.scrollHeight;
      let start = 0;
      if (sl > 0) {
        start = parseInt((this.vScroll.dMax * sl) / max);
      }
      if (start !== this.vScroll.dStart) {
        this.vScroll.dStart = start;
        this.pageChanged();
      }
    },
    setVScrollMax(rowCount) {
      this.vScroll.dMax = rowCount;
      const rowHeight = this.vScroll.lineHeight;
      this.vScroll.maxHeight = rowCount * rowHeight + "px";
    },
    documentChanged(doc) {
      this.$store.dispatch("docs/updateDoc", doc);
      this.filterMatches();
    },
    formatValue(column, value) {
      if (["due_date", "completed_date"].some((x) => x === column.value))
        return this.formatDate(value);
      else return value;
    },
    formatDate(value) {
      return value ? dayjs(value).format("D MMM YYYY") : "";
    },
    parseDate(date) {
      if (!date) return null;
      return dayjs(date).format("YYYY-MM-DD");
    },
    initView() {
      this.internalViewDef = JSON.parse(JSON.stringify(this.ViewDef));
      _sourceData = this.$store.getters["tasks/list"];
      // this.setView();
    },
    setView() {
      this.setColumns();
      this.filterMatches();
    },
    filterMatches(sameState) {
      if (!sameState) this.stateKey++;
      let statuses = this.ViewDef.statuses;
      let sourcedata = _sourceData;
      let columnFilters = this.internalViewDef.columnFilters
        ? this.internalViewDef.columnFilters
            .filter((f) => f.filterSettings.isActive)
            .map((f) => {
              let cf = {
                column: f.value,
                name: f.text,
                values: f.filterSettings.values
                  .filter((v) => v.selected)
                  .map((v) => v.value),
              };
              cf.title = `${cf.name} = [${cf.values.join(", ")}]`;
              return cf;
            })
        : [];
      this.filterList = JSON.parse(JSON.stringify(columnFilters));
      if (columnFilters.length) {
        sourcedata = sourcedata.filter((x) => {
          return columnFilters.every((f) =>
            f.values.some((v) => x[f.column] === v)
          );
        });
      }
      let visibleFilters = this.filtersVisible
        ? this.filtersVisible
            .filter((f) => f.filterValues.length)
            .map((f) => {
              return {
                column: f.value,
                name: f.text,
                values: f.filterValues,
              };
            })
        : [];
      if (visibleFilters.length) {
        sourcedata = sourcedata.filter((x) => {
          return visibleFilters.every((f) =>
            f.values.some((v) => x[f.column] === v)
          );
        });
      }
      this.tasks = statuses.length
        ? sourcedata.filter((d) =>
            statuses.some((s) => s === d.doc_status_text)
          )
        : sourcedata;
      // this.tasks = rows.filter((d) => d.filteredItems.length);
      this.setupInternalRows();
      this.setVisibleRows();
      this.pageChanged(0);
    },
    setupInternalRows() {
      let internal_rows = [];
      let addRows = (rows, level, parentKey) => {
        rows.forEach((r, ri) => {
          const key = `${parentKey ? parentKey + "_" : ""}${r.doc_id}`;
          internal_rows.push({
            level: level,
            detail: r,
            key: key,
            parentKey: parentKey,
            // hasChildren: !!r.filteredItems?.length,
            // childCount: r.filteredItems?.length || 0,
            expanded: false,
            selected: false,
            visible: level === 0,
            index: ri,
            visibleChildren: 0,
            cssClassRow: level > 0 ? "sub-row" : "",
            cssClassColumns: this.detailColumnsUsed.map((c, ci) =>
              ci === 0
                ? "first-column"
                : ci === this.detailColumnsUsed.length - 1
                ? ""
                : ""
            ),
          });
          // if (r.filteredItems) {
          //   addRows(r.filteredItems, level + 1, key);
          // }
        });
      };
      addRows(this.tasks, 0, null);
      this.internal_rows = internal_rows;
    },
    setVisibleRows() {
      this.visible_rows = this.internal_rows.filter((x) => x.visible);
      this.sort();
      this.setVScrollMax(this.visible_rows.length);
    },
    getCellStyle(row, colIndex) {
      return colIndex === 0
        ? {
            paddingLeft: row.level * 40 + "px",
          }
        : null;
    },
    sort() {
      if (this.sortColumn.name) {
        const col = this.sortColumn.name;
        const isNum = this.sortColumn.isNumber;
        const dir = this.sortColumn.descending ? -1 : 1;
        const setSortKey = (rows, parent) => {
          rows.forEach((r) => {
            r.sortKey =
              (parent?.sortKey || "") +
              (isNum
                ? r.detail[col] || 0
                : r.detail[col]?.toLowerCase().trim() || "");
            if (r.expanded) {
              setSortKey(
                this.visible_rows.filter(
                  (x) => x.level === r.level + 1 && x.parentKey === r.key
                ),
                r
              );
            }
          });
        };
        setSortKey(this.visible_rows.filter((x) => x.level === 0));
        this.visible_rows.sort(
          (a, b) =>
            dir * (a.sortKey > b.sortKey ? 1 : a.sortKey < b.sortKey ? -1 : 0)
        );
      }
    },
    setSort(column) {
      this.sortColumn = column;
      this.setVisibleRows();
      this.pageChanged(0);
    },
    applyColumnFilters(filters) {
      this.internalViewDef.columnFilters = filters;
      this.filterMatches(filters.some((f) => f.filterSettings.isActive));
    },
    removeColumnFilter(f) {
      let lvfilter = this.internalViewDef.columnFilters.find(
        (x) => x.value === f.column
      );
      if (lvfilter) {
        lvfilter.filterSettings.values.forEach((x) => {
          x.selected = false;
          x.applied = false;
        });
        lvfilter.filterSettings.isActive = false;
        this.filterMatches();
      }
    },
    selectDocument(row) {
      row.selected = !row.selected;
      if (row.selected) this.selectedDocs.push(row);
      else
        this.selectedDocs.filter((x) => x.detail.doc_id !== row.detail.doc_id);
    },
    compareDocDetailsFull() {
      this.fullCompareView.show = true;
      this.fullCompareView.items = this.selectedDocs.map((dm) => {
        return {
          doc_id: dm.doc_id || dm.detail.doc_id,
          doc_name: dm.doc_name || dm.detail.doc_name,
          match_pct_name: dm.match_pct_name,
          match_pct_content: dm.match_pct_content,
        };
      });
    },
    compareDocDetails() {
      this.sideBySide.show = true;
      this.sideBySide.items = this.selectedDocs.map((dm) => {
        return {
          doc_id: dm.doc_id || dm.detail.doc_id,
          system_number: dm.detail.system_number,
          doc_name: dm.doc_name || dm.detail.doc_name,
        };
      });
    },
    resetCompare() {
      this.selectedDocs.splice(0, this.selectedDocs.length);
      this.internal_rows.forEach((x) => (x.selected = false));
    },
    pageScroll(data) {
      if (data) {
        this.vScroll.dStart +=
          (data.deltaY >= 0 ? 1 : -1) * this.vScroll.pageRows;
        this.pageChanged();
      }
    },
    pageChanged(start) {
      if (start === undefined) start = this.vScroll.dStart;
      if (start < 0) start = 0;
      if (start >= this.vScroll.dMax - 1)
        start = this.vScroll.dMax - this.vScroll.pageRows;
      this.vScroll.dStart = start;
      this.vScroll.dEnd = start + this.vScroll.pageRows;

      if (this.$refs.scrollContainer) {
        let max = this.$refs.scrollContainer.scrollHeight;
        this.$refs.scrollContainer.scrollTop =
          (max * this.vScroll.dStart) / this.vScroll.dMax;
      }

      this.showCurentPage();
    },
    showCurentPage() {
      this.pageRows = this.visible_rows.slice(
        this.vScroll.dStart,
        this.vScroll.dEnd
      );
    },
    setColumns() {
      this.filtersVisible = jaCommon.populateFilterData(
        utils.taskListFields.filter((x) => this.ViewDef.filtersVisible.some((c) => c === x.value)),
        _sourceData);
      this.detailColumnsUsed = utils.taskListFields.filter((x) =>
        this.ViewDef.columnsVisible.some((c) => c === x.value)
      );
      this.stateKey++;
    },
    selectRow(event, item) {
      if (this.rowClickAction === "menu") {
        this.openContextMenu(event, item);
      } else if (this.rowClickAction === "openTask") {
        this.openTask(item);
      } else {
        this.openDocumentSummary(event, item);
      }
    },
    cellClick(event, column, item) {
      if (column.link === "task") {
        this.openTask(item);
      } else if (column.link === "document_summary") {
        this.openDocumentSummary(event, item);
      } else if (column.link === "document") {
        this.openDocument(item);
      }
    },
    openDocument(item) {
      this.contextMenu = false;
      this.$emit("openDocument", item);
    },
    openDocumentSummary(event, item) {
      this.documentSummary.doc_id = item.doc_id;
      this.documentSummary.trigger = event;
    },
    openContextMenu(e, item) {
      this.currentTask = item;
      e.preventDefault();
      this.contextMenu = false;
      this.posX = e.clientX;
      this.posY = e.clientY;
      this.$nextTick(() => {
        this.contextMenu = true;
      });
    },
    openTask(task) {
      let possibleError = false;
      if (task.task_status === "Cancelled") {
        alert("Can't edit a Cancelled task");
        return;
      }
      this.currentTask = task;

      axios
        .get("workflow/task/" + task.document_task_id)
        .then((resp) => {
          possibleError = true;
          if (resp.data.Status === "OK") {
            this.taskDialogue.document_task = resp.data.Data.document_task;
            this.taskDialogue.user_list = resp.data.Data.user_list;
            this.taskDialogue.user_id_assigned =
              resp.data.Data.document_task.user_id_assigned;
            this.taskDialogue.due_date = resp.data.Data.document_task.due_date;
            this.taskDialogue.due_date_text =
              resp.data.Data.document_task.due_date_text;
            this.taskDialogue.show = true;
          }
          this.response = resp.data;
        })
        .catch((err) => {
          if (possibleError) {
            alert("Code Error");
          } else if (err.response && err.response.status === 401) {
            this.$emit("sessionExpired", err);
          } else {
            alert(err.response ? err.response.data.message : err);
          }
          console.log(err);
        });
    },
    saveTask(cancelTask) {
      let possibleError = false;
      let userName = "";

      let data = { ...this.taskDialogue.document_task };
      data.reassigned = 0;
      data.isCancelled = !!cancelTask;
      data.isDirty = false;
      if (
        this.taskDialogue.document_task.user_id_assigned !==
        this.taskDialogue.user_id_assigned
      ) {
        data.user_id_assigned = this.taskDialogue.user_id_assigned;
        userName = data.user_id_assigned
          ? this.taskDialogue.user_list.find(
              (x) => x.user_id === data.user_id_assigned
            ).user_name
          : "UNASSIGNED";
        data.reassigned = 1;
        data.isDirty = true;
      }
      if (
        this.taskDialogue.document_task.due_date !== this.taskDialogue.due_date
      ) {
        data.due_date = this.taskDialogue.due_date;
        data.due_date_text = this.formatDate(this.taskDialogue.due_date);
        data.isDirty = true;
      }
      if (!data.isDirty && !cancelTask) {
        this.taskDialogue.show = false;
        return;
      }
      this.taskDialogue.busy = true;

      axios
        .post("workflow/updateTask/", data)
        .then((resp) => {
          possibleError = true;
          if (resp.data.Status === "OK") {
            if (cancelTask) {
              this.currentTask.task_status = "Cancelled";
              this.currentTask.task_status_colour = "yellow";
              this.currentTask.user_name_assigned = "";
            } else {
              this.currentTask.due_date = data.due_date;
              if (data.reassigned) {
                this.currentTask.user_name_assigned = userName;
                this.currentTask.task_status = "Open";
                this.currentTask.task_status_colour = "amber";
              }
            }
            this.taskDialogue.show = false;
          }
          this.taskDialogue.busy = false;
          this.response = resp.data;
        })
        .catch((err) => {
          if (possibleError) {
            alert("Code Error");
          } else if (err.response && err.response.status === 401) {
            this.$emit("sessionExpired", err);
          } else {
            alert(err.response ? err.response.data.message : err);
          }
          console.log(err);
          this.taskDialogue.busy = false;
        });
    },
  },
};
</script>
  <style lang="scss" scoped>
@import "@/assets/styles/vars";

.filter-col {
  flex-grow: 1;
  flex-shrink: 0;
  max-width: 50%;
  @media (min-width: 960px) {
    max-width: 25%;
  }
  @media (min-width: 1264px) {
    max-width: 14%;
  }
}

.btn-background {
  height: 44px;
  ::v-deep .v-input__slot {
    background: transparent !important;
  }
}

::v-deep .v-select__selections {
  overflow: hidden;
  white-space: nowrap;
  flex-flow: nowrap;
}

th.tf {
  border: 1px solid #d9d9d9;
  background-color: #eeeeee !important;
}
th.th {
  font-weight: bold;
  text-transform: uppercase;
}
th.tf {
  border-bottom-left-radius: 20px;
  border-bottom-right-radius: 20px;
}
tfoot tr {
  position: sticky;
  bottom: 0;
}
.similarity-label {
  background-color: #eeeeee;
  color: black;
  font-weight: 700;
  font-size: 14px;
  font-family: "DM Sans" !important;
  border-radius: 8px;
  padding: 2px 8px;
  height: 22px;
}
.showAsLink {
  text-decoration: underline;
}
.showAsLink:hover {
  color: green;
  cursor: pointer;
}
</style>
  